import React from 'react';
import { RectangularChip } from 'framework/components/chips/RectangularChip';
import { ICustomerAccount } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';

interface IProps {
	ca: ICustomerAccount;
	style?: React.CSSProperties;
}

export const CustomerAccountStatusChip = ({ ca, style }: IProps) => {
	const strings = useLocalization();

	return (
		<RectangularChip
			style={style}
			label={ca.hasOutstandingBalance ? strings.open : strings.settled}
			fill={ca.hasOutstandingBalance}
			color={ca.hasOutstandingBalance ? 'warning' : 'success'}
		/>
	);
};
